"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ru_RU = _interopRequireDefault(require("../../date-picker/locale/ru_RU"));
var _default = _ru_RU["default"];
exports["default"] = _default;